import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getFeatureFlags } from '../../api/auth';

export const fetchFeatureFlags = createAsyncThunk(
  'featureFlags/fetchFeatureFlags',
  async (_, { rejectWithValue }) => {
    try {
      const data = await getFeatureFlags();
      if (data?.success && data.data) {
        return {
          isGoogleEnable: data.data.isGoogleEnable ?? true,
          isMetaEnable: data.data.isMetaEnable ?? false,
          isAppleEnable: data.data.isAppleEnable ?? false,
          isFaceEnabled: data.data.isFaceEnabled ?? false,
        };
      }
      return data?.data || {};
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  flags: {
    isGoogleEnable: true,
    isMetaEnable: false,
    isAppleEnable: false,
    isFaceEnabled: false,
  },
  loading: false,
  loaded: false,
  error: null,
};

const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {
    setFeatureFlags: (state, action) => {
      state.flags = { ...state.flags, ...action.payload };
      state.loaded = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeatureFlags.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFeatureFlags.fulfilled, (state, action) => {
        state.loading = false;
        state.loaded = true;
        state.flags = { ...state.flags, ...action.payload };
      })
      .addCase(fetchFeatureFlags.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setFeatureFlags } = featureFlagsSlice.actions;
export default featureFlagsSlice.reducer;
